/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/default-props-match-prop-types */
import React, { FC, ReactNode } from 'react';
import { styled } from 'linaria/react';
import { Text } from '@mtsbank/ui-kit';
import { useTheme, withTheme } from '@shared/lib';
import { OldTextProps } from '@shared/ui/atoms/OldText';
export interface InputHelperTextProps extends OldTextProps {
  hasError?: boolean;
  children: ReactNode;
}

// @ts-ignore
const InputHelperText: FC<InputHelperTextProps> = ({
  hasError,
  children,
  ...rest
}) => {
  const theme = useTheme();
  return children && <HelperText color={theme.colors.text.secondary} {...rest}>
        {children}
      </HelperText>;
};
InputHelperText.defaultProps = {
  hasError: false,
  children: ''
};

// @ts-ignore
const _exp = /*#__PURE__*/() => Text;
const _exp2 = /*#__PURE__*/() => ({
  theme
}: ThemeProps) => theme.font.family.MTSCompact;
const _exp3 = /*#__PURE__*/() => ({
  theme
}: ThemeProps) => theme.font.size.xxxs;
const _exp4 = /*#__PURE__*/() => ({
  theme
}: ThemeProps) => theme.font.weight.regular;
const _exp5 = /*#__PURE__*/() => ({
  theme
}: ThemeProps) => theme.font.lineHeight.xxxs;
const HelperText = withTheme(/*#__PURE__*/styled(_exp())({
  name: "HelperText",
  class: "h18xkl15",
  propsAsIs: true,
  vars: {
    "h18xkl15-0": [_exp2()],
    "h18xkl15-1": [_exp3(), "px"],
    "h18xkl15-2": [_exp4()],
    "h18xkl15-3": [_exp5(), "px"]
  }
}));
export default InputHelperText;

require("./InputHelperText.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./InputHelperText.tsx");